export const CloseMobile = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="2.06066" y1="1" x2="15.8492" y2="14.7886" stroke="#1E3665" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="0.75" y1="-0.75" x2="20.25" y2="-0.75" transform="matrix(-0.707107 0.707107 0.707107 0.707107 16 1)" stroke="#1E3665" strokeWidth="1.5" strokeLinecap="round"/>
  </svg> 
)